import React from 'react';
import './LoaderMini.css';

const LoaderMini = () =>
            <div className="loader-outer-wrapper">
                <div className="loader-wrapper">
                    <div className="loader">
                        <div className="roller" />
                        <div className="roller" />
                    </div>

                    <div id="loader2" className="loader">
                        <div className="roller" />
                        <div className="roller" />
                    </div>

                    <div id="loader3" className="loader">
                        <div className="roller" />
                        <div className="roller" />
                    </div>
                </div>
            </div>;

export default LoaderMini;